import React from 'react';
import './SalesOverviewCard.css';
import { formatCurrency } from '../utilities/formatCurrency';
import { Clock, TrendingUp, TrendingDown } from 'lucide-react';

const DailySalesOverviewCard = ({ TodaystotalSales, TodaystotalTests, TodaystotalAmount, salesPercentageChange, amountPercentageChange, isLoading = true }) => {
  return (
    <div className="sales-overview-card">
       <div className="top-right-icon" style={{ background: 'linear-gradient(135deg, rgba(6,182,212,0.12), rgba(34,211,238,0.1))' }}>
        <Clock className="sales-icon" size={22} strokeWidth={2.2} style={{ color: '#0891b2' }} />
      </div>
      <div className="main-content">
        <div className="title">Today's Sales</div>
        <div className="value-container">
          <div className="value">{isLoading ? <span className="skeleton skeleton-text lg" /> : `${TodaystotalSales} Sales`}</div>
          <div className="percentage-change">
              {isLoading ? (
                  <span className="skeleton skeleton-text lg" style={{ width: '60px' }} />
              ) : (
                  salesPercentageChange >= 0 ? (
                      <span className="positive"><TrendingUp className="arrow-icon" size={14} /> {salesPercentageChange.toFixed(1)}%</span>
                  ) : (
                      <span className="negative"><TrendingDown className="arrow-icon" size={14} /> {salesPercentageChange.toFixed(1)}%</span>
                  )
              )}
          </div>
        </div>
      </div>
      <div className="sub-content-container">
        <div className="sub-content-item">
          <div className="sub-title">Amount</div>
          <div className="value-container">
            <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : formatCurrency(TodaystotalAmount.toFixed(2))}</div>
            <div className="percentage-change">
                {isLoading ? (
                    <span className="skeleton skeleton-text lg" style={{ width: '60px' }} />
                ) : (
                    amountPercentageChange >= 0 ? (
                        <span className="positive"><TrendingUp className="arrow-icon" size={12} /> {amountPercentageChange.toFixed(1)}%</span>
                    ) : (
                        <span className="negative"><TrendingDown className="arrow-icon" size={12} /> {amountPercentageChange.toFixed(1)}%</span>
                    )
                )}
            </div>
          </div>
        </div>
        <div className="sub-content-item">
          <div className="sub-title">Tests</div>
          <div className="sub-value">{isLoading ? <span className="skeleton skeleton-text lg" /> : TodaystotalTests}</div>
        </div>
      </div>
    </div>
  );
};

export default DailySalesOverviewCard;
